export default __webpack_public_path__ + "static/media/EmployeeFinder.43de338d.gif";